import { create } from 'zustand';
import { api } from '@/lib/api';
import type { ApiResponse } from '@nexus/shared/types';

export interface PriorityItem {
  id: string;
  type: string;
  priority: number;
  title: string;
  description: string;
  entityType: string;
  entityId: string;
  actionLabel: string;
  actionUrl: string;
}

interface PriorityState {
  items: PriorityItem[];
  isLoading: boolean;
  error: string | null;
  fetch: () => Promise<void>;
  dismiss: (id: string) => void;
}

export const usePriorityStore = create<PriorityState>((set) => ({
  items: [],
  isLoading: false,
  error: null,
  fetch: async () => {
    set({ isLoading: true, error: null });
    try {
      const res = await api.get<ApiResponse<PriorityItem[]>>('/api/priority/feed');
      set({ items: res.data ?? [], isLoading: false });
    } catch (err: unknown) {
      set({ error: (err as Error).message, isLoading: false });
    }
  },
  dismiss: (id) =>
    set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
}));
